import { URLS } from '@/constants'

export default {
  namespaced: true,

  state: {
    eventSource: null,
    connected: false,
    reconnectAttempts: 0,
    maxReconnectAttempts: 5,
    reconnectDelay: 3000, // 3 seconds
    reconnectTimer: null,
  },

  mutations: {
    SET_EVENT_SOURCE(state, eventSource) {
      state.eventSource = eventSource
    },

    SET_CONNECTED(state, connected) {
      state.connected = connected
    },

    INCREMENT_RECONNECT_ATTEMPTS(state) {
      state.reconnectAttempts++
    },

    RESET_RECONNECT_ATTEMPTS(state) {
      state.reconnectAttempts = 0
    },

    SET_RECONNECT_TIMER(state, timer) {
      state.reconnectTimer = timer
    },
  },

  actions: {
    /**
     * Подключиться к SSE stream для получения real-time обновлений продаж
     */
    connect({ commit, dispatch, state, rootState }) {
      // Если уже подключены, не создаём новое соединение
      if (state.eventSource) {
        return
      }

      const shopId = rootState.cashRegister.cashRegisterData?.id
      if (!shopId) {
        return
      }

      const url = `${URLS.MODEL.SALE.SALES_STREAM_URL}?shopId=${shopId}`

      const eventSource = new EventSource(url, {
        withCredentials: true,
      })

      eventSource.onopen = () => {
        commit('SET_CONNECTED', true)
        commit('RESET_RECONNECT_ATTEMPTS')
      }

      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data)
          dispatch('handleSaleEvent', data)
        } catch (error) {
          console.error('[SSE] Error parsing event data:', error)
        }
      }

      eventSource.onerror = () => {
        commit('SET_CONNECTED', false)

        if (eventSource) {
          eventSource.close()
          commit('SET_EVENT_SOURCE', null)
        }

        const isAuthorized = rootState.authentication.isAuthorized
        if (isAuthorized && state.reconnectAttempts < state.maxReconnectAttempts) {
          commit('INCREMENT_RECONNECT_ATTEMPTS')
          const timer = setTimeout(() => {
            commit('SET_RECONNECT_TIMER', null)
            dispatch('connect')
          }, state.reconnectDelay)
          commit('SET_RECONNECT_TIMER', timer)
        }
      }

      commit('SET_EVENT_SOURCE', eventSource)
    },

    /**
     * Отключиться от SSE stream
     */
    disconnect({ commit, state }) {
      if (state.reconnectTimer) {
        clearTimeout(state.reconnectTimer)
        commit('SET_RECONNECT_TIMER', null)
      }
      if (state.eventSource) {
        state.eventSource.close()
        commit('SET_EVENT_SOURCE', null)
        commit('SET_CONNECTED', false)
        commit('RESET_RECONNECT_ATTEMPTS')
      }
    },

    /**
     * Обработать событие о продаже
     */
    handleSaleEvent({ dispatch }, event) {
      const { type, sale } = event

      // Игнорировать служебные события
      if (type === 'connected' || type === 'heartbeat') {
        return
      }

      switch (type) {
        case 'created':
          // Добавить в список кассовых операций (KassaOperationsComponent)
          dispatch('transaction/addTransactionFromSSE', sale, { root: true })
          // Добавить в список поиска продаж
          dispatch('salesSearch/addSale', sale, { root: true })
          // Обновить баланс
          window.dispatchEvent(new CustomEvent('sale-changed'))
          break

        case 'deleted':
          // Удалить из списка кассовых операций
          dispatch('transaction/removeTransactionFromSSE', sale.id, { root: true })
          // Удалить из списка поиска продаж
          dispatch('salesSearch/removeSale', sale.id, { root: true })
          // Обновить баланс
          window.dispatchEvent(new CustomEvent('sale-changed'))
          break

        case 'updated':
          dispatch('salesSearch/updateSale', sale, { root: true })
          break

        default:
          console.warn('[SSE] Unknown event type:', type)
      }
    },
  },

  getters: {
    isConnected: (state) => state.connected,
  },
}
